import axios from "axios";
import store from "./store";

let pendingRequests = 0;

function loadingEnd() {
  pendingRequests--;
  if (pendingRequests == 0) store.commit("loadingEnd");
}

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.interceptors.request.use(
  config => {
    const hideLoading = config.hideLoading;
    if (!hideLoading) {
      pendingRequests++;
      store.commit("loadingStart");
    }

    let token = localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },

  error => {
    loadingEnd();
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    const hideLoading = response.config.hideLoading;
    if (!hideLoading) loadingEnd();
    return response;
  },
  error => {
    const hideLoading = error.config.hideLoading;
    if (!hideLoading) loadingEnd();
    let message;
    if (error.response) {
      if (error.response.data.message) message = error.response.data.message;
      else message = error.response.data;
    } else message = "Erro no servidor";
    store.commit("showError", message);
    return Promise.reject(error);
  }
);
